import InstantApp from '../InstantApp'
import settings from './settings'
import customFields from './customFields'
import * as integrationType from '../../../constants/integrationType'
import { INSTAGRAM_SHOPPABLE } from '../../../constants/templateCategory'
import thumbnail from '../assets/thumb.png'

export const information = {
  id: 'insta',
  title: 'Insta Commerce',
  image: thumbnail,
  thumbnailPath: [ 'intro', 'image' ],
  category: INSTAGRAM_SHOPPABLE,
  description: 'Instagram-oriented template.',
  integrations: [ integrationType.SHOPIFY ],
  instantApp: InstantApp,
  defaultSettings: settings,
  disabled: true
}

export function getTemplate (app) {
  return {
    id: information.id,
    customFields,
    settings
  }
}



// WEBPACK FOOTER //
// ./src/templates/insta/template/index.js